import { Divider, ToggleButton, ToggleButtonGroup } from '@mui/material';

export type SnapshotsOrigin = 'eon' | 'other';

export const SnapshotOriginToggleButtons = (props: {
  selectedOrigin: SnapshotsOrigin;
  onSnapshotOriginSelected: (origin: SnapshotsOrigin) => void;
}) => {
  const { selectedOrigin, onSnapshotOriginSelected } = props;

  return (
    <>
      <ToggleButtonGroup
        exclusive
        value={selectedOrigin}
        onChange={(e, value) => {
          if (value === null) {
            // Keep the current selection
            return;
          }
          onSnapshotOriginSelected(value);
        }}
      >
        <ToggleButton value='eon'>Eon</ToggleButton>
        <ToggleButton value='other'>Non-Eon</ToggleButton>
      </ToggleButtonGroup>
      <Divider orientation='vertical' flexItem variant='middle' />
    </>
  );
};
